@if (siteLoading) {
  <div style="width: 100%;text-align: center;">
    <div style="display:flex;justify-content: center;align-items: center"><mat-spinner></mat-spinner></div><br>
  </div>
} @else {
  <div class="login-content">
    <div class="login-card">

      <div class="img-agent prima-logo">
        <img src="assets/img/prima-logo.png">
      </div>
      <div class="img-agent prima-text">
        Přihlášení
      </div>
      <mat-card appearance="outlined">
        <mat-card-content>
          <form [formGroup]="emailForm">
            <mat-form-field class="inp-email">
              <mat-label>Zadejte váš e-mail</mat-label>
              <input formControlName="email" name="email" type="email" matInput (keyup.enter)="sendMail()">
            </mat-form-field>
            @if (disableInputs && loading) {
              <button type="submit"
                      mat-flat-button
                      color="primary"
                      class="btn-email"
                      disabled>
                <mat-spinner [diameter]="20" color="primary"></mat-spinner>
              </button>
            }
            @else if (disableInputs && !loading && !errorMsg) {
              <button type="submit"
                      mat-flat-button
                      color="primary"
                      class="btn-email"
                      disabled>
                <mat-icon>check</mat-icon>
                Odesláno
              </button>
            }
            @else if (disableInputs && !loading && errorMsg) {
              <button type="submit"
                      mat-flat-button
                      color="primary"
                      class="btn-email"
                      disabled>
                <mat-icon>close</mat-icon>
                Chyba
              </button>
            }
            @else {
              <button type="submit"
                      [disabled]="!emailForm.valid"
                      mat-flat-button
                      color="primary"
                      class="btn-email"
                      (click)="sendMail()">
                <mat-icon>mark_email_read</mat-icon>
                Odeslat přihlašovací odkaz
              </button>
            }
          </form>
          @if (errorMsg) {
            <small style="color:red"><mat-icon slot="start">error</mat-icon> Přihlašovací odkaz se nepodařilo odeslat z následujícího důvodu:<br><code>{{errorMsg}}</code></small>
          }
        </mat-card-content>
      </mat-card>
    </div>
    <button style="right: 5px;bottom: 5px;position: absolute;" color="secondary" mat-icon-button [routerLink]="['/admin/login']">
      <mat-icon slot="start">lock_open</mat-icon>
    </button>
  </div>
}
